<template>
  <div
    v-if="type.options.length>0"
    class="q-list"
  >
    <div class="option-item">
      <div
        v-if="type.type==='input'"
        class="blanksframe"
        disabled="disabled"
      ></div>
      <div
        v-else
        class="option"
        @mouseenter="editStyle"
        @mouseleave="editStyle"
      >
        <div
          :class="['content-editable',{'editable-focus':contentfocus}]"
          tabindex="0"
          @focus.capture="contentfocus=true"
          @blur.capture="contentfocus=false"
        >
          <i
            class="fa-lg"
            :class="type.type | getIcon"
          ></i>
          <v-input
            v-model="option.text"
            class="option_title"
            :data-is-open="option.setting.show"
            tabindex="0"
            disabled="disabled"
          ></v-input>
        </div>
        <div
          v-if="contentfocus?true:a"
          class="option-operate"
        >
          <i
            v-if="type.type!=='select'"
            class="fa fa-cog fa-lg setting"
            @click="settingOption(option)"
          ></i>
          <i
            class="fa fa-minus-square-o fa-lg delete"
            @click.stop="deleteOption(type.id,option.id)"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VInput from "./v-input";
export default {
  props: {
    type: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    option: {
      type: [Object, Number],
      required: true,
      default: function() {
        return {};
      }
    },
    index: {
      type: Number,
      required: true,
      default: 1
    }
  },
  data() {
    return {
      a: false,
      contentfocus: false
    };
  },
  methods: {
    settingOption(option) {
      this.$emit("settingOption", option);
    },
    deleteOption(qid, oid) {
      this.$emit("deleteOption", qid, oid);
    },
    editStyle() {
      this.a = !this.a;
    }
  },
  components: {
    VInput
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/variables.less";

.q-list {
  padding-right: 228px;
}

.option-item {
  width: 100%;
  margin: 6px 0 0;
  padding: 0 0 0 24px;
  position: relative;
  box-sizing: border-box;

  .blanksframe {
    height: 32px;
    line-height: 20px;
    border-radius: 2px;
    background-color: #fff;
    margin-right: 108px;
    border: 1px solid #d8d8d8;
    position: relative;
    font-size: 14px;
    padding: 5px 10px;
    box-sizing: border-box;
    color: #484848;
    overflow: hidden;
  }

  .option {
    position: relative;

    .drag {
      position: absolute;
      top: 6px;
      left: -24px;
    }

    .content-editable {
      position: relative;
      margin-right: 108px;
      box-sizing: border-box;
      border-radius: 2px;
      border: solid 1px transparent;
      color: #484848;

      i {
        color: #aaaaaa;
        position: absolute;
        top: 8px;
        left: 14px;
      }

      .option_title {
        padding: 5px 10px 5px 38px;
        font-size: 14px;
        line-height: 1.43;
        min-height: 20px;
        word-wrap: break-word;
      }

      .option_title[data-is-open="true"]:after {
        content: "";
        display: inline-block;
        width: 70px;
        height: 18px;
        border: solid 1px #d8d8d8;
        border-radius: 2px;
        background-color: #ffffff;
        margin-left: 14px;
        vertical-align: top;
      }
    }

    .content-editable:hover {
      border: dashed 1px #aaaaaa;
      padding: 0;
      background-color: #ffffff;
    }

    .content-editable.editable-focus {
      background-color: #f4f4f4;
      border: solid 1px #f4f4f4;
      padding: 0;
    }

    .option-operate {
      position: absolute;
      width: 108px;
      right: 0;
      top: 0;
      padding: 4px 0;

      i {
        color: #aaaaaa;
        margin-left: 20px;
      }

      .setting:hover {
        cursor: pointer;
        color: @deepblue;
      }

      .delete:hover {
        cursor: pointer;
        color: #eb7461;
      }
    }
  }
}
</style>
